import { render, staticRenderFns } from "./tab4.vue?vue&type=template&id=6207bffe&scoped=true&"
import script from "./tab4.vue?vue&type=script&lang=js&"
export * from "./tab4.vue?vue&type=script&lang=js&"
import style0 from "./tab4.vue?vue&type=style&index=0&id=6207bffe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6207bffe",
  null
  
)

export default component.exports